import { render, staticRenderFns } from "./ShowResultModal.vue?vue&type=template&id=2f6fbfb0&scoped=true"
import script from "./ShowResultModal.vue?vue&type=script&lang=js"
export * from "./ShowResultModal.vue?vue&type=script&lang=js"
import style0 from "./ShowResultModal.vue?vue&type=style&index=0&id=2f6fbfb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6fbfb0",
  null
  
)

export default component.exports